enum NotificationMessages {
  SUCCESS_PASSWORD_CHANGE = 'Your password has been changed successfully.',
  PASSWORD_RESET_LINK_SENT = 'Instructions to reset your password will be sent to you. Please check your email.'
}

export default NotificationMessages;
